// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__BA3O-","Logo":"Header_Logo__28YaI","LogoText":"Header_LogoText__T6opq"};